import { render } from "./Transformer.vue?vue&type=template&id=6bb816cb"
import script from "./Transformer.vue?vue&type=script&lang=js"
export * from "./Transformer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__